export default __webpack_public_path__ + "static/media/Rain.5380eba1.png";